import { useMutation } from "@tanstack/react-query";
import { createSchool as apiCreateSchool } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateSchool() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: createSchool, isPending, data: results, error } = useMutation({
        mutationFn: (req) => apiCreateSchool(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/schools');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createSchool, results };
}
